import LegalLayout, { LegalSection, LegalList } from "./LegalLayout";

export default function PolicyPage() {
  return (
    <LegalLayout
      title="운영정책"
      subtitle="K-ArtPEN 서비스의 운영 기준 및 제재 정책을 안내합니다."
      updatedAt="2026년 3월 27일"
    >
      <LegalSection title="제1조 (목적)">
        <p>본 운영정책은 주식회사 툴뮤직이 운영하는 K-ArtPEN 서비스의 건전한 이용 환경 조성과 이용자 보호를 위한 세부 운영 기준을 정의합니다.</p>
      </LegalSection>

      <LegalSection title="제2조 (계정 운영 기준)">
        <p><strong className="text-[#CCCCCC]">계정 생성 및 관리</strong></p>
        <LegalList items={[
          "1인 1계정 원칙: 동일인이 복수의 계정을 생성·이용하는 것을 금지합니다.",
          "계정 양도 금지: 계정의 타인 양도, 대여는 금지됩니다.",
          "비밀번호 관리: 계정 비밀번호는 이용자 스스로 관리하며, 타인과 공유하지 않습니다.",
          "6개월 이상 미접속 계정은 휴면 처리될 수 있습니다.",
        ]} />
      </LegalSection>

      <LegalSection title="제3조 (워크스페이스 운영 기준)">
        <p><strong className="text-[#CCCCCC]">강사 운영 기준</strong></p>
        <LegalList items={[
          "강사 계정은 교육 목적으로만 워크스페이스를 운영해야 합니다.",
          "학생 개인정보를 수집·이용 시 관련 법령을 준수해야 합니다.",
          "이벤트 발송 기능은 교육적 목적 내에서만 사용해야 합니다.",
          "1개의 강사 계정당 최대 10개 워크스페이스를 운영할 수 있습니다.",
        ]} />
        <p className="mt-3"><strong className="text-[#CCCCCC]">학생 참여 기준</strong></p>
        <LegalList items={[
          "정해진 워크스페이스 내에서만 시뮬레이션을 진행합니다.",
          "팀원과의 협력 및 역할 분담을 성실히 수행해야 합니다.",
          "다른 팀의 워크스페이스에 무단 접근하는 행위를 금지합니다.",
        ]} />
      </LegalSection>

      <LegalSection title="제4조 (금지 행위)">
        <p>다음 행위를 발견 시 사전 통보 없이 계정 정지 또는 영구 탈퇴 처리될 수 있습니다.</p>
        <LegalList items={[
          "시스템 해킹, 데이터 조작, 치트 도구 사용",
          "다른 이용자의 계정 도용 또는 사칭",
          "서비스 콘텐츠의 무단 복제 및 상업적 이용",
          "욕설, 혐오 표현, 타인을 비하하는 콘텐츠 생성",
          "교육 목적 외 서비스 이용 (스팸 발송, 광고 등)",
          "회사의 사전 승인 없이 서비스를 이용한 상업 행위",
        ]} />
      </LegalSection>

      <LegalSection title="제5조 (서비스 이용 제한)">
        <p><strong className="text-[#CCCCCC]">단계별 제재 기준</strong></p>
        <LegalList items={[
          "1단계: 경고 (약관 위반 행위 시 이메일 통보)",
          "2단계: 일시 정지 (7일 ~ 30일, 반복 위반 시)",
          "3단계: 영구 정지 (중대 위반 또는 3회 이상 반복 위반)",
        ]} />
        <p className="mt-3">이의 신청은 제재 조치 후 7일 이내에 <span className="text-[#7A9BFF]">eunhyun1@naver.com</span>으로 가능합니다.</p>
      </LegalSection>

      <LegalSection title="제6조 (서비스 변경 및 중단)">
        <LegalList items={[
          "회사는 서비스 개선을 위해 기능을 추가, 변경, 삭제할 수 있습니다.",
          "중요 변경사항은 시행 7일 전 사전 공지합니다.",
          "정기 점검: 매주 화요일 오전 2~4시 (상황에 따라 변동)",
          "서비스 중단 시 회사는 이로 인한 직접적 손해를 보상하지 않습니다.",
        ]} />
      </LegalSection>

      <LegalSection title="제7조 (콘텐츠 정책)">
        <p>K-ArtPEN의 모든 시뮬레이션 시나리오, NPC 대화, 이벤트 내용은 교육 목적으로 제작된 가상의 설정입니다. 실제 기업, 인물, 사건과는 무관합니다.</p>
      </LegalSection>

      <LegalSection title="제8조 (문의 및 신고)">
        <p>운영정책 위반 행위 신고 또는 문의는 아래로 연락 바랍니다.</p>
        <LegalList items={[
          "이메일: eunhyun1@naver.com",
          "처리 기간: 영업일 기준 3일 이내",
          "운영 시간: 평일 오전 10시 ~ 오후 6시",
        ]} />
      </LegalSection>

      <LegalSection title="부칙">
        <p>본 운영정책은 2026년 3월 27일부터 시행합니다.</p>
      </LegalSection>
    </LegalLayout>
  );
}
